"use client";

import { useSetAtom } from "jotai";
import { useCallback, useEffect, useRef } from "react";
import { PannelVisible, ShowItemIndex } from "./Pannel";

export default function Nav(props: { children: React.ReactNode }) {
  const navRef = useRef<HTMLDivElement>(null);

  const navIndicator = useRef<HTMLDivElement>(null);

  const setShow = useSetAtom(PannelVisible);

  const setShowIndex = useSetAtom(ShowItemIndex);

  const updateIndicator = useCallback((element: HTMLElement) => {
    const indicator = navIndicator.current;

    if (!indicator) return;

    const nav = navRef.current;

    const navRect = nav?.getBoundingClientRect();

    const left = navRect?.left ?? 0;

    const rect = element.getBoundingClientRect();

    indicator.style.width = `${rect.width}px`;
    indicator.style.left = `${rect.left - left}px`;
  }, []);

  useEffect(() => {
    if (!navRef.current) return;

    const nav = navRef.current;

    const indicator = navIndicator.current;

    const navItems = document.querySelectorAll(".nav-item");

    nav.addEventListener("mouseleave", () => {
      if (!indicator) return;
      setShow(false);
      setShowIndex(null);
      indicator.style.width = "0px";
    });

    navItems.forEach((item) => {
      item.addEventListener("mouseover", (event) => {
        updateIndicator(event.target as HTMLElement);
      });
    });
  }, [updateIndicator, setShow, setShowIndex]);

  return (
    <nav
      ref={navRef}
      className="relative hidden h-full w-full transition-all duration-300 md:block"
      id="app-nav">
      {props.children}

      <div
        ref={navIndicator}
        className="absolute bottom-0 z-0 h-1 rounded bg-[#A42127] transition-all duration-300"></div>
    </nav>
  );
}
